import type {ExperimentAssignmentEnvelopeV1} from '@github-ui/experiments/internal'

export interface EmbeddedMetadata {
  title?: string
  experiment_assignment?: ExperimentAssignmentEnvelopeV1
  /**
   * Embedded payload keys whose `payload[key]` is proto3-JSON. A key is the
   * backend payload's `route_id`: the route id for `mainQuery`, or the query
   * name for a top-level secondary query. The client decodes these with the
   * matching query's schema during first-paint hydration; other keys stay raw.
   */
  protoRoutes?: string[]
}

export interface EmbeddedData {
  // payload per route
  payload: unknown
  // payload for the app
  appPayload?: Record<string, unknown>
  title?: string
  meta?: EmbeddedMetadata
}

export interface EmbeddedPartialData {
  props: object
  meta?: EmbeddedMetadata
}

export function withoutExperimentAssignment<T extends {meta?: EmbeddedMetadata}>(data: T): T {
  if (data.meta?.experiment_assignment === undefined) return data

  const {experiment_assignment: _experimentAssignment, ...meta} = data.meta
  return {...data, meta}
}
